var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Item',{attrs:{"image":_vm.image,"video":_vm.video,"text":_vm.post.text,"post":_vm.post},nativeOn:{"click":function($event){return _vm.postClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }